export default "__VITE_ASSET__k2t1qcVd__"